var map = {
	"./bxzj-active.png": "6feb",
	"./cwzb-active.png": "1074",
	"./gspj-active.png": "e16a",
	"./gzfx-active.png": "f6f1",
	"./jgdy-active.png": "c138",
	"./rzrj-active.png": "4bfd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32b5";